import React from 'react';
import { ShoppingCartIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
export function HowToReceive() {
  const steps = [{
    num: '1',
    title: 'Comprás',
    icon: ShoppingCartIcon
  }, {
    num: '2',
    title: 'Pagás',
    icon: CreditCardIcon
  }, {
    num: '3',
    title: 'Descargás',
    icon: DownloadIcon
  }];
  return <section className="bg-[#0E1F19] py-4 px-3 border-b border-[#1F3D2B]" data-id="element-87">
      <div className="max-w-2xl mx-auto flex flex-row items-center justify-center gap-6 md:gap-10" data-id="element-88">
        {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-89">
            <div className="w-10 h-10 rounded-full bg-[#102A1F] border border-[#D4A843] flex items-center justify-center mb-1.5 shadow-sm" data-id="element-90">
              <step.icon className="w-5 h-5 text-[#D4A843]" strokeWidth={2.5} data-id="element-91" />
            </div>
            <span className="font-black text-[#FFFFFF] text-xs md:text-sm uppercase leading-none" data-id="element-92">
              {step.num}. {step.title}
            </span>
          </div>)}
      </div>
    </section>;
}